import Cookies from 'js-cookie';
import { Outlet } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/app-sidebar/app-sidebar';
import { AppHeaderProvider } from '@/components/app-header/app-header-context';
import { AppHeader } from '@/components/app-header/app-header';
import { ThemeProvider } from './theme-mode-context';
export function AppLayout() {
  const sidebarState = Cookies.get('sidebar:state');
  const defaultOpen = sidebarState ? sidebarState === 'true' : true;

  return (
    <ThemeProvider>
      <SidebarProvider defaultOpen={defaultOpen}>
        <AppSidebar />
        <SidebarInset>
          <AppHeaderProvider>
            <AppHeader />
            <div className={cn('w-full py-6 px-4 mx-auto max-w-[1234px]')}>
              <Outlet />
            </div>
          </AppHeaderProvider>
        </SidebarInset>
      </SidebarProvider>
    </ThemeProvider>
  );
}
